import StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy from './StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy'

export default function StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy() {}

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype = new StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy()

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.init = function(timeFormat, groupNameProvider, includeOtherUsersColumn) {
    StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype.init.call(this, timeFormat, groupNameProvider)
    this.includeOtherUsersColumn = includeOtherUsersColumn
    return this
}

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.getDepartmentHeaderColumnWidth = function() {
    return this.includeOtherUsersColumn ? 2 : 3
}

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.addSecondHeaderRowCells = function(secondHeaderRow) {
    this.addCell(secondHeaderRow, this.message("report.subtotal"), "subtotal")
    this.addCreatedCell(secondHeaderRow, this.createUserHeaderCell())
    if (!this.includeOtherUsersColumn) this.addCreatedCell(secondHeaderRow, this.createUserHeaderCell())
}

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.addDataCells = function(row) {
    this.addTimeValueCell(row, "spent")
    this.addTimeValueCell(row)
    this.addTimeValueCell(row)
    this.addTimeValueCell(row)
}


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.js